/*
 * Blog posts data – Hebrew content for Upsite digital agency blog
 * Categories: SEO, בניית אתרים, שיווק דיגיטלי, AI
 */

export interface BlogPost {
  slug: string;
  title: string;
  excerpt: string;
  content: string[];
  category: string;
  date: string;
  readTime: number;
  image: string;
  author: string;
  featured?: boolean;
}

export const categories = [
  { id: "all", label: "הכל" },
  { id: "seo", label: "SEO" },
  { id: "web", label: "בניית אתרים" },
  { id: "marketing", label: "שיווק דיגיטלי" },
  { id: "ai", label: "AI" },
];

export const blogPosts: BlogPost[] = [
  {
    slug: "seo-tips-2026",
    title: "10 טיפים לקידום אורגני שכל עסק חייב להכיר ב-2026",
    excerpt: "קידום אורגני משתנה כל הזמן. הנה 10 הטיפים הכי חשובים שיעזרו לכם להישאר בראש תוצאות החיפוש של גוגל ב-2026.",
    category: "seo",
    date: "2026-02-15",
    readTime: 8,
    author: "צוות אפסייט",
    featured: true,
    image: "https://d2xsxph8kpxj0f.cloudfront.net/310519663396493078/EDyimBtawRo3FYhzWUwDs6/blog-seo-tips-7qB5Raib8WxdzLpKsQ7mNM.webp",
    content: [
      "קידום אורגני (SEO) הוא אחד הכלים החזקים ביותר שעומדים לרשות עסקים שרוצים לצמוח באונליין. אבל האלגוריתמים של גוגל משתנים כל הזמן, ומה שעבד אתמול לא בהכרח יעבוד מחר. ב-2026, יש כמה שינויים משמעותיים שחשוב להכיר.",
      "## 1. התמקדו בתוכן שעונה על שאלות אמיתיות\n\nגוגל ממשיך לשפר את היכולת שלו להבין כוונת חיפוש. במקום לכתוב תוכן סביב מילות מפתח בלבד, התמקדו ביצירת תוכן שעונה על שאלות אמיתיות שהקהל שלכם שואל. השתמשו בכלים כמו Google Search Console ו-Answer the Public כדי לזהות שאלות נפוצות.",
      "## 2. מהירות אתר היא קריטית\n\nCore Web Vitals ממשיכים להיות גורם דירוג חשוב. ודאו שהאתר שלכם נטען מהר, עם LCP (Largest Contentful Paint) מתחת ל-2.5 שניות. אופטימיזציה של תמונות, שימוש ב-CDN ומינימום JavaScript מיותר יכולים לעשות הבדל משמעותי.",
      "## 3. חוויית משתמש במובייל\n\nיותר מ-60% מהחיפושים בגוגל מתבצעים ממכשירים ניידים. ודאו שהאתר שלכם מותאם לחלוטין למובייל, עם ניווט נוח, טקסט קריא וכפתורים בגודל מתאים.",
      "## 4. E-E-A-T: ניסיון, מומחיות, סמכות ואמינות\n\nגוגל מדגיש יותר ויותר את חשיבות ה-E-E-A-T (Experience, Expertise, Authoritativeness, Trustworthiness). הראו שאתם מומחים בתחום שלכם באמצעות תוכן מעמיק, ביוגרפיות של כותבים, ציטוטים ממקורות אמינים ועדויות מלקוחות.",
      "## 5. בניית קישורים איכותיים\n\nקישורים נכנסים ממשיכים להיות אחד מגורמי הדירוג החשובים ביותר. התמקדו בבניית קישורים מאתרים רלוונטיים ואיכותיים, באמצעות תוכן שווה שיתוף, שיתופי פעולה ויחסי ציבור דיגיטליים.",
      "## 6. אופטימיזציה לחיפוש קולי\n\nעם העלייה בשימוש בעוזרים קוליים, חשוב לייעל את התוכן שלכם גם לחיפושים קוליים. השתמשו בשפה טבעית, ענו על שאלות ישירות וצרו תוכן בפורמט שאלה-תשובה.",
      "## 7. תוכן וידאו ומולטימדיה\n\nגוגל מציג יותר ויותר תוצאות וידאו בדפי החיפוש. שלבו תוכן וידאו באתר שלכם, עם תמלולים ותיאורים מפורטים שיעזרו לגוגל להבין את התוכן.",
      "## 8. Schema Markup\n\nהשתמשו ב-Schema Markup כדי לעזור לגוגל להבין את המבנה של התוכן שלכם. זה יכול לשפר את ההופעה שלכם בתוצאות החיפוש עם Rich Snippets שמגדילים את שיעור הקליקים.",
      "## 9. עדכון תוכן ישן\n\nאל תשכחו לעדכן תוכן ישן באתר שלכם. גוגל מעדיף תוכן עדכני ורלוונטי. עברו על מאמרים ישנים, עדכנו מידע, הוסיפו נתונים חדשים ושפרו את האיכות.",
      "## 10. ניתוח מתחרים\n\nלמדו מהמתחרים שלכם. נתחו את האתרים שמדורגים מעליכם – מה הם עושים נכון? איזה תוכן הם מפרסמים? איזה קישורים יש להם? השתמשו בתובנות האלה כדי לשפר את האסטרטגיה שלכם.",
      "## סיכום\n\nקידום אורגני ב-2026 דורש גישה הוליסטית שמשלבת תוכן איכותי, טכנולוגיה מתקדמת וחוויית משתמש מעולה. אם אתם רוצים לשפר את הדירוג שלכם בגוגל, צרו קשר עם הצוות של אפסייט ונבנה יחד אסטרטגיית SEO שמביאה תוצאות."
    ],
  },
  {
    slug: "modern-website-design-trends",
    title: "טרנדים בעיצוב אתרים ב-2026: מה חם ומה לא",
    excerpt: "עולם עיצוב האתרים מתפתח במהירות. גלו את הטרנדים החמים ביותר שישפיעו על עיצוב אתרים ב-2026 ואיך ליישם אותם.",
    category: "web",
    date: "2026-01-28",
    readTime: 6,
    author: "צוות אפסייט",
    image: "https://d2xsxph8kpxj0f.cloudfront.net/310519663396493078/EDyimBtawRo3FYhzWUwDs6/blog-web-design-3iJqUkvSZCLah4M3HyefZr.webp",
    content: [
      "עיצוב אתרים הוא תחום שמשתנה כל הזמן. מה שנראה מודרני ומרשים לפני שנתיים, עלול להיראות מיושן היום. ב-2026, יש כמה טרנדים מרכזיים שכדאי להכיר ולשלב באתר שלכם.",
      "## עיצוב מינימליסטי עם עומק\n\nהמינימליזם ממשיך לשלוט, אבל עם טוויסט – שימוש בשכבות, צללים עדינים ואפקטים של זכוכית (Glassmorphism) שיוצרים תחושת עומק ומרחב. הגישה הזו שומרת על ממשק נקי אבל מוסיפה עניין ויזואלי.",
      "## אנימציות מיקרו\n\nאנימציות קטנות ועדינות שמגיבות לפעולות המשתמש – כמו hover effects, מעברים חלקים ואלמנטים שנכנסים לתצוגה בגלילה – משפרות את חוויית המשתמש ומוסיפות תחושה של איכות ומקצועיות.",
      "## טיפוגרפיה דומיננטית\n\nשימוש בגופנים גדולים ובולטים כאלמנט עיצובי מרכזי. שילוב של גופנים שונים – אחד לכותרות ואחד לגוף הטקסט – יוצר היררכיה ויזואלית ברורה ומעניינת.",
      "## צבעים עזים וגרדיאנטים\n\nגרדיאנטים חוזרים בגדול, עם שילובי צבעים נועזים שיוצרים אפקטים ויזואליים מרשימים. השימוש בצבעים עזים כנקודות מיקוד מושך את העין ויוצר זהות ויזואלית חזקה.",
      "## Dark Mode כברירת מחדל\n\nיותר ויותר אתרים בוחרים ב-Dark Mode כעיצוב ברירת המחדל. זה לא רק נראה מודרני – זה גם נוח לעיניים, חוסך סוללה במכשירים ניידים ומאפשר לצבעים ותמונות לבלוט.",
      "## עיצוב מותאם נגישות\n\nנגישות היא כבר לא אופציה – היא חובה. עיצוב שמתחשב בכל המשתמשים, כולל אנשים עם מוגבלויות, הוא לא רק הדבר הנכון לעשות – הוא גם משפר את ה-SEO ואת חוויית המשתמש לכולם.",
      "## סיכום\n\nהטרנדים של 2026 מדגישים חוויית משתמש, נגישות ועיצוב שמשלב אסתטיקה עם פונקציונליות. באפסייט, אנחנו מיישמים את הטרנדים האלה בכל אתר שאנחנו בונים – כי אנחנו מאמינים שאתר טוב הוא אתר שגם נראה מעולה וגם עובד מעולה."
    ],
  },
  {
    slug: "content-marketing-strategy",
    title: "איך לבנות אסטרטגיית תוכן שמביאה לידים",
    excerpt: "שיווק באמצעות תוכן הוא אחד הכלים היעילים ביותר לגיוס לקוחות. למדו איך לבנות אסטרטגיית תוכן שעובדת באמת.",
    category: "marketing",
    date: "2026-01-10",
    readTime: 7,
    author: "צוות אפסייט",
    image: "https://d2xsxph8kpxj0f.cloudfront.net/310519663396493078/EDyimBtawRo3FYhzWUwDs6/blog-digital-marketing-HRm4hkwNHPkzfpLZcm4cKY.webp",
    content: [
      "שיווק באמצעות תוכן (Content Marketing) הוא אחד הכלים החזקים ביותר שעומדים לרשות עסקים שרוצים לגדול באונליין. אבל תוכן סתם – בלי אסטרטגיה – הוא בזבוז זמן וכסף. הנה איך לעשות את זה נכון.",
      "## הגדירו את קהל היעד\n\nלפני שאתם כותבים מילה אחת, אתם צריכים לדעת בדיוק למי אתם כותבים. צרו פרסונות (Personas) מפורטות שכוללות מאפיינים דמוגרפיים, אתגרים, צרכים ושאלות שהקהל שלכם שואל.",
      "## מחקר מילות מפתח\n\nהשתמשו בכלים כמו Google Keyword Planner, Ahrefs או SEMrush כדי לזהות מילות מפתח רלוונטיות עם נפח חיפוש גבוה ותחרות סבירה. זה הבסיס לתוכן שאנשים באמת מחפשים.",
      "## צרו לוח תוכן\n\nתכננו את התוכן שלכם מראש. לוח תוכן חודשי או רבעוני יעזור לכם לשמור על עקביות, לכסות נושאים מגוונים ולהתאים את התוכן לעונות ואירועים רלוונטיים.",
      "## כתבו תוכן שנותן ערך אמיתי\n\nהתוכן שלכם צריך לפתור בעיות, לענות על שאלות או ללמד משהו חדש. תוכן שנותן ערך אמיתי בונה אמון, מושך קישורים טבעיים ומעודד שיתופים.",
      "## קדמו את התוכן\n\nלכתוב תוכן מעולה זה רק חצי מהעבודה. אתם צריכים גם לקדם אותו – ברשתות החברתיות, בניוזלטר, בקבוצות רלוונטיות ובשיתופי פעולה עם אתרים אחרים.",
      "## מדדו ושפרו\n\nעקבו אחרי הביצועים של התוכן שלכם – כמה תנועה הוא מביא? כמה לידים? מה שיעור ההמרה? השתמשו בנתונים כדי לשפר את האסטרטגיה ולהתמקד במה שעובד.",
      "## סיכום\n\nאסטרטגיית תוכן טובה היא מרתון, לא ספרינט. זה דורש סבלנות, עקביות ונכונות להשקיע. אבל התוצאות – תנועה אורגנית, לידים איכותיים ומיתוג חזק – שוות את ההשקעה. צרו קשר עם אפסייט ונבנה יחד אסטרטגיית תוכן שמביאה תוצאות."
    ],
  },
  {
    slug: "ai-revolution-digital-marketing",
    title: "מהפכת ה-AI בשיווק דיגיטלי: מה צריך לדעת",
    excerpt: "בינה מלאכותית משנה את עולם השיווק הדיגיטלי. גלו איך AI יכול לעזור לעסק שלכם לצמוח מהר יותר וחכם יותר.",
    category: "ai",
    date: "2024-12-20",
    readTime: 9,
    author: "צוות אפסייט",
    image: "https://d2xsxph8kpxj0f.cloudfront.net/310519663396493078/EDyimBtawRo3FYhzWUwDs6/blog-ai-marketing-TjwxJTFgTwtbA9G5QwmzmK.webp",
    content: [
      "בינה מלאכותית (AI) כבר לא עניין של עתיד – היא כאן, עכשיו, ומשנה את הדרך שבה עסקים משווקים את עצמם באונליין. מיצירת תוכן ועד ניתוח נתונים, AI פותח אפשרויות חדשות שלא היו קיימות לפני כמה שנים.",
      "## יצירת תוכן באמצעות AI\n\nכלים כמו ChatGPT, Claude ו-Gemini מאפשרים ליצור תוכן איכותי במהירות. אבל חשוב להבין – AI הוא כלי, לא תחליף. התוכן הטוב ביותר נוצר כשמשלבים את היכולות של AI עם הידע והניסיון האנושי.",
      "## ניתוח נתונים מתקדם\n\nAI מאפשר לנתח כמויות עצומות של נתונים ולהפיק תובנות שלא ניתן לגלות ידנית. מזיהוי טרנדים ועד חיזוי התנהגות לקוחות – AI הופך את קבלת ההחלטות לחכמה ומדויקת יותר.",
      "## פרסונליזציה בקנה מידה\n\nAI מאפשר להתאים את חוויית המשתמש לכל מבקר באופן אישי – מהתוכן שהוא רואה ועד ההצעות שהוא מקבל. פרסונליזציה מגדילה את שיעורי ההמרה ומשפרת את שביעות הרצון.",
      "## אוטומציה של תהליכים\n\nAI מאפשר לייעל תהליכי שיווק שגוזלים זמן – מניהול קמפיינים ועד שליחת מיילים מותאמים אישית. זה משחרר זמן לצוות שלכם להתמקד באסטרטגיה ויצירתיות.",
      "## חיפוש ו-SEO בעידן ה-AI\n\nגוגל משלב AI בתוצאות החיפוש (AI Overviews), מה שמשנה את הדרך שבה אנשים מוצאים מידע. עסקים צריכים להתאים את אסטרטגיית ה-SEO שלהם לעידן החדש.",
      "## צ'אטבוטים ושירות לקוחות\n\nצ'אטבוטים מבוססי AI יכולים לספק שירות לקוחות 24/7, לענות על שאלות נפוצות ולהפנות פניות מורכבות לנציגים אנושיים. זה משפר את חוויית הלקוח ומפחית עלויות.",
      "## סיכום\n\nמהפכת ה-AI בשיווק דיגיטלי היא הזדמנות עצומה לעסקים שיודעים לנצל אותה. באפסייט, אנחנו משלבים כלי AI מתקדמים באסטרטגיות השיווק שלנו כדי להביא תוצאות טובות יותר, מהר יותר. רוצים לשמוע איך AI יכול לעזור לעסק שלכם? דברו איתנו."
    ],
  },
  {
    slug: "website-speed-optimization",
    title: "מהירות אתר: למה זה חשוב ואיך לשפר",
    excerpt: "מהירות טעינה של אתר משפיעה על SEO, על חוויית המשתמש ועל שיעורי ההמרה. הנה מדריך מקיף לשיפור מהירות האתר שלכם.",
    category: "web",
    date: "2024-12-05",
    readTime: 5,
    author: "צוות אפסייט",
    image: "https://d2xsxph8kpxj0f.cloudfront.net/310519663396493078/EDyimBtawRo3FYhzWUwDs6/blog-web-design-3iJqUkvSZCLah4M3HyefZr.webp",
    content: [
      "מהירות האתר שלכם היא לא רק עניין טכני – היא משפיעה ישירות על ההכנסות שלכם. מחקרים מראים שכל שנייה נוספת בזמן הטעינה מפחיתה את שיעור ההמרה ב-7%. גוגל גם משתמש במהירות כגורם דירוג.",
      "## למה מהירות חשובה?\n\nמשתמשים מצפים שאתר ייטען תוך 3 שניות או פחות. אם האתר שלכם איטי, הם פשוט יעברו למתחרים. בנוסף, גוגל מדרג אתרים מהירים גבוה יותר בתוצאות החיפוש.",
      "## אופטימיזציה של תמונות\n\nתמונות הן לרוב הגורם הגדול ביותר לאיטיות. השתמשו בפורמטים מודרניים כמו WebP, דחסו תמונות בלי לפגוע באיכות והשתמשו ב-lazy loading כדי לטעון תמונות רק כשהן נכנסות לתצוגה.",
      "## שימוש ב-CDN\n\nרשת הפצת תוכן (CDN) מפזרת את הקבצים שלכם על שרתים ברחבי העולם, כך שכל מבקר מקבל את התוכן מהשרת הקרוב אליו ביותר. זה יכול לשפר את זמן הטעינה משמעותית.",
      "## מינימום JavaScript ו-CSS\n\nקוד מיותר מאט את האתר. הסירו קוד שלא בשימוש, מזגו קבצים והשתמשו ב-minification כדי להקטין את גודל הקבצים.",
      "## Caching חכם\n\nהגדירו caching נכון כדי שמבקרים חוזרים לא יצטרכו לטעון את כל הקבצים מחדש. Browser caching ו-server-side caching יכולים לשפר את הביצועים משמעותית.",
      "## סיכום\n\nשיפור מהירות האתר הוא אחד ההשקעות עם ההחזר הגבוה ביותר שאתם יכולים לעשות. באפסייט, כל אתר שאנחנו בונים עובר אופטימיזציה מקיפה למהירות. רוצים לבדוק את מהירות האתר שלכם? דברו איתנו."
    ],
  },
  {
    slug: "local-seo-guide",
    title: "מדריך SEO מקומי: איך להופיע ראשונים בחיפושים מקומיים",
    excerpt: "SEO מקומי הוא קריטי לעסקים שמשרתים אזור גיאוגרפי מסוים. למדו איך לייעל את הנוכחות המקומית שלכם בגוגל.",
    category: "seo",
    date: "2024-11-18",
    readTime: 7,
    author: "צוות אפסייט",
    image: "https://d2xsxph8kpxj0f.cloudfront.net/310519663396493078/EDyimBtawRo3FYhzWUwDs6/blog-seo-tips-7qB5Raib8WxdzLpKsQ7mNM.webp",
    content: [
      "אם יש לכם עסק שמשרת לקוחות באזור גיאוגרפי מסוים – מסעדה, קליניקה, חנות או כל עסק מקומי – SEO מקומי הוא חיוני. כשמישהו מחפש בגוגל \"מסעדה איטלקית בתל אביב\" או \"רופא שיניים ליד הבית\", אתם רוצים להופיע בתוצאות הראשונות.",
      "## Google Business Profile\n\nהצעד הראשון והחשוב ביותר הוא ליצור ולייעל את הפרופיל העסקי שלכם בגוגל (Google Business Profile). מלאו את כל הפרטים – שם, כתובת, טלפון, שעות פעילות, תמונות ותיאור מפורט.",
      "## ביקורות לקוחות\n\nביקורות חיוביות בגוגל הן אחד מגורמי הדירוג החשובים ביותר ב-SEO מקומי. עודדו לקוחות מרוצים להשאיר ביקורות, והגיבו לכל ביקורת – חיובית ושלילית.",
      "## NAP עקבי\n\nוודאו שהשם, הכתובת והטלפון (NAP) של העסק שלכם זהים בכל מקום באינטרנט – באתר, בגוגל, בפייסבוק, במדריכים עסקיים ובכל פלטפורמה אחרת.",
      "## תוכן מקומי\n\nצרו תוכן שרלוונטי לאזור שלכם. כתבו על אירועים מקומיים, שתפו פעולה עם עסקים מקומיים אחרים וצרו דפי נחיתה לאזורים ספציפיים שאתם משרתים.",
      "## Schema Markup מקומי\n\nהוסיפו Local Business Schema Markup לאתר שלכם כדי לעזור לגוגל להבין את המיקום ואת סוג העסק שלכם. זה יכול לשפר את ההופעה שלכם בתוצאות החיפוש המקומיות.",
      "## סיכום\n\nSEO מקומי הוא אחד הכלים היעילים ביותר לעסקים מקומיים. עם האסטרטגיה הנכונה, אתם יכולים להופיע בראש תוצאות החיפוש כשלקוחות פוטנציאליים מחפשים את השירותים שלכם. צרו קשר עם אפסייט ונעזור לכם לשלוט בחיפושים המקומיים."
    ],
  },
];

export function getPostBySlug(slug: string): BlogPost | undefined {
  return blogPosts.find((p) => p.slug === slug);
}

export function getPostsByCategory(category: string): BlogPost[] {
  if (category === "all") return blogPosts;
  return blogPosts.filter((p) => p.category === category);
}

export function getRelatedPosts(currentSlug: string, limit = 3): BlogPost[] {
  const current = getPostBySlug(currentSlug);
  if (!current) return blogPosts.slice(0, limit);
  return blogPosts
    .filter((p) => p.slug !== currentSlug && p.category === current.category)
    .concat(blogPosts.filter((p) => p.slug !== currentSlug && p.category !== current.category))
    .slice(0, limit);
}

export function formatDate(dateStr: string): string {
  const months = [
    "ינואר", "פברואר", "מרץ", "אפריל", "מאי", "יוני",
    "יולי", "אוגוסט", "ספטמבר", "אוקטובר", "נובמבר", "דצמבר",
  ];
  const d = new Date(dateStr);
  return `${d.getDate()} ב${months[d.getMonth()]} ${d.getFullYear()}`;
}
